import PopupCheats, { Item } from 'src/game/cheats/PopupCheats';
import { CheatData } from 'src/game/cheats/cheats.sequences';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { closeAllPopups } from 'src/lib/popups/popupOpenClose';
import {
  clearMatch2GameplayState,
  saveMatch2GameplayState,
} from './match2-savestate.utils';
import { getGameScene } from '../game/getGameScene';
import { user } from 'src/StateObserver';

const MATCH2_SAVE_STATE = 'match2 Save State';

const list = () => {
  const cheats: Record<string, CheatData[]> = {};

  cheats[MATCH2_SAVE_STATE] = [
    {
      text: 'Save Gameplay State',
      color: 'secondary',
      cheat: async () => {
        if (!getGameScene()) {
          window.alert('You must be playing match2 to save the gameplay state');
          return;
        }
        await saveMatch2GameplayState('cheat', user().match2.level);
        closeAllPopups();
      },
      gameplay: true,
    },
    {
      text: 'Save & Load Gameplay State',
      color: 'secondary',
      cheat: async () => {
        if (!getGameScene()) {
          window.alert('You must be playing match2 to save the gameplay state');
          return;
        }
        await saveMatch2GameplayState('cheat', user().match2.level);
        closeAllPopups();
        window.location.reload();
      },
      gameplay: true,
    },
    {
      text: 'Clear Gameplay State',
      color: 'secondary',
      cheat: async () => {
        clearMatch2GameplayState();
        closeAllPopups();
      },
      gameplay: true,
    },
  ];

  return cheats;
};

const ui = (args: {
  key: string;
  popup: PopupCheats;
  item: Item;
  title: LangBitmapFontTextView;
  setting: CheatData[];
  parent: Item | null;
}) => {
  switch (args.key) {
    case MATCH2_SAVE_STATE:
      args.title.updateOpts({
        width: args.item.style.width - 40,
        height: 20,
        y: 8,
        align: 'center',
      });
      args.popup.createVerticalButtons(args.item, args.setting);
      break;
  }
};

export const match2SaveStateCheats = {
  list,
  ui,
};
